<template>
  <form
    autocomplete="off"
    class="gap-0 gap-y-4 "
    @submit.prevent="submitForm"
  >
    <div class="col-span-12 mx-auto text-center w-full">
      <h2 class="">
        {{ device ? 'Edit' : 'Add' }} Device
      </h2>

      <TextInput
        v-model="formData.name"
        label="Name"
        class="mb-8"
        :validation-error="errors && 'name' in errors && errors.name[0]"
        autofocus
      />

      <div class="flex gap-3">
        <AppButton
          :disabled="processing"
          class="btn btn-outline btn-secondary py-2.5 w-full"
          @click="$emit('close')"
        >
          Cancel
        </AppButton>

        <AppButton
          :processing="processing"
          class="btn btn-solid btn-secondary py-2.5 w-full"
        >
          {{ processing ? 'Confirming' : 'Confirm' }}
        </AppButton>
      </div>
    </div>
  </form>
</template>

<script setup>
import { reactive } from 'vue';

import { AppButton } from '@/components/app';
import { TextInput } from '@/components/forms/inputs';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  device: {
    type: Object,
    default: () => {},
  },
  errors: {
    type: Object,
    default: () => {},
  },
  processing: Boolean,
});

const formData = reactive({
  name: props.device?.name || null,
  event: props.device?.event?.id || null,
});

const submitForm = () => {
  if (!props.processing) {
    emit('confirm', formData);
  }
};
</script>
